import { ArrowUpRight, Instagram } from "lucide-react";

export default function InstagramBanner() {
  return (
    <aside className="instagram-banner" aria-label="Follow us on Instagram">
      <a
        href="https://www.instagram.com/balogunpersonalshopper"
        target="_blank"
        rel="noopener noreferrer"
        className="instagram-banner-link"
      >
        <Instagram className="h-6 w-6 shrink-0" aria-hidden="true" />
        <span className="min-w-0">
          <span className="block font-semibold">See our latest finds on Instagram</span>
          <span className="block text-xs sm:text-sm">@balogunpersonalshopper</span>
        </span>
        <ArrowUpRight className="h-5 w-5 shrink-0" aria-hidden="true" />
      </a>
    </aside>
  );
}
